var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digifarm-logo",class:{ minimized: _vm.minimized }},[_c('router-link',{attrs:{"to":"/dashboard"}},[_c('img',{attrs:{"src":require("@/assets/digifarm-logo.png"),"alt":"digifarm-logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }